import React from 'react'
import styled from 'styled-components';
import { Link, navigate } from 'gatsby';

const Pagination = ({currentPage, numPages, url}) => {
  if(numPages === 1 || typeof numPages === 'undefined') return null

  const handleClick = (e, link) => {
    e.preventDefault();
    navigate(link)
  }

  return (
    <Wrapper>
    {[...Array(numPages)].map((_,i) => {
      const link = i === 0 ? url : `${url}${i + 1}/`;
      return (
        <StyledLink 
          to={link} 
          key={i} 
          onClick={(e) => handleClick(e, link)}
        >
          <PageNum 
            key={i}
            $isActive={currentPage === i + 1}
          >
            {i + 1}
          </PageNum>
        </StyledLink>
      )
    })}
    </Wrapper>
  )
}

export default Pagination

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 10px 0; 
`;

const PageNum = styled.div`
  height: 30px;
  width: 30px;
  background-color: ${props => props.$isActive ? '#F19D9A' : 'white'};
  color:${props => props.$isActive ? 'white' : '#F19D9A'};
  display:grid;
  place-items:center;
  border-radius:4px;
  border:${props => props.$isActive ? 'none' : '1.5px solid #F19D9A'};
  
`;